import { updateAllHeaderCustomProperties } from '@theme/utilities';

class ShippingBanner extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-dismiss]');
    if (!btn) return;
    btn.addEventListener('click', () => this.#dismiss());
  }

  #dismiss() {
    const key = this.dataset.storageKey;
    this.classList.add('shipping-banner--dismissing');
    try {
      if (key) localStorage.setItem(key, '1');
    } catch (e) {}
    const finish = () => {
      this.hidden = true;
      this.removeEventListener('transitionend', finish);
      try {
        updateAllHeaderCustomProperties();
      } catch (e) {}
    };
    this.addEventListener('transitionend', finish);
    setTimeout(finish, 500);
  }
}

if (!customElements.get('shipping-banner')) {
  customElements.define('shipping-banner', ShippingBanner);
}
